import React from "react";
import { TextAndModelFileSliceFragment } from "../../types/graphql";
import { PrismicRichText, SliceComponentProps } from "@prismicio/react";
import { htmlSerializer } from "../../utils/htmlSerializer";
import { Slice } from "@prismicio/types";
import { IPageContext } from "../../types/types";
import { SharedSliceType } from "../shared-slice/shared-slice";
import HoopsAndCta from "../hoops-and-cta/hoops-and-cta";
import { track } from "../../utils/analytics";
import { ErrorBoundary } from "react-error-boundary";
import {
  Badge,
  BulletPoint,
  BulletPoints,
  Checkmark,
  HoopsViewerAndCTAWrapper,
  TextAndModelFileBase,
  TextBlock,
  TextTitle,
  Text,
} from "./text-and-model-file.styled";
import * as FA from "../../styles/fontawesome";

export type ITextAndModelFileProps = Slice<
  SharedSliceType.text_and_image,
  TextAndModelFileSliceFragment["primary"],
  TextAndModelFileSliceFragment["items"][number]
> & { type: SharedSliceType };

const TextAndModelFile = ({
  slice,
  context,
}: SliceComponentProps<ITextAndModelFileProps, IPageContext>) => {
  var textAndModelFile = slice.primary;
  let bullets = slice.items;

  return textAndModelFile ? (
    <TextAndModelFileBase>
      <Text alignment={slice.slice_label}>
        {textAndModelFile.display_new_badge && <Badge>New!</Badge>}
        {textAndModelFile.title && (
          <TextTitle>{textAndModelFile.title}</TextTitle>
        )}
        {textAndModelFile.text && (
          <TextBlock>
            <PrismicRichText
              field={textAndModelFile.text.richText}
              components={htmlSerializer}
            />
          </TextBlock>
        )}
        {bullets && bullets.length > 0 && (
          <BulletPoints css={FA.BulletedList}>
            {bullets.map((bullet, index) => {
              return (
                bullet &&
                bullet.bullet_point && (
                  <BulletPoint key={index}>
                    <>
                      <Checkmark css={[FA.ListBullet, FA.CheckRegular]} />
                      {bullet.bullet_point}
                    </>
                  </BulletPoint>
                )
              );
            })}
          </BulletPoints>
        )}
      </Text>
    </TextAndModelFileBase>
  ) : (
    <></>
  );
};

export default TextAndModelFile;
